export const RecruitmentHubRoutes = [
    {
        "url": "/recruitment-hub/jobs",
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.harriSH.access-portal.jobs",
        "type": "frontend",
        "platformPage": true,
        "params": {},
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/recruitment-hub/recruitment-hub.downgrade.module");
                }
            },
            { path: "d3", type: "library", "name": "d3" },
            { path: "c3", type: "library", "name": "c3" }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['recruitment-hub'],
        },
    },
    {
        "url": "/recruitment-hub/applicants?job_id&job_pos_cat_code&bucket_id&app_id&single&brand_id&hide_images",
        "loginRequired": true,
        "platformPage": true,
        "showGlobalSearch": true,
        "name": "appLayout.harriSH.access-portal.applicants",
        "type": "frontend",
        "params": {
            job_id: { dynamic: true },
            job_pos_cat_code: { dynamic: true },
            bucket_id: { dynamic: true },
            app_id: { dynamic: true },
            brand_id: { dynamic: true },
            single: { dynamic: true },
            hide_images: { dynamic: true }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/recruitment-hub/recruitment-hub.downgrade.module");
                }
            },
            { path: "d3", type: "library", "name": "d3" },
            { path: "c3", type: "library", "name": "c3" }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['recruitment-hub'],
        },
    },
    {
        "url": "/recruitment-hub/upload-candidates",
        "loginRequired": true,
        "platformPage": true,
        "showGlobalSearch": true,
        "name": "appLayout.harriSH.access-portal.upload-candidates",
        "type": "frontend",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/recruitment-hub/recruitment-hub.downgrade.module");
                }
            }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['recruitment-hub'],
        },
    },
    {
        "url": "/recruitment-hub/interview-schedule?date&job_id&job_pos_cat_code&bucket_id&app_id&single&brand_id&hide_images",
        "loginRequired": true,
        "platformPage": true,
        "showGlobalSearch": true,
        "name": "appLayout.harriSH.access-portal.interview-schedule",
        "type": "frontend",
        "params": {
            job_id: { dynamic: true },
            job_pos_cat_code: { dynamic: true },
            bucket_id: { dynamic: true },
            app_id: { dynamic: true },
            brand_id: { dynamic: true },
            single: { dynamic: true },
            hide_images: { dynamic: true }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/recruitment-hub/recruitment-hub.downgrade.module");
                }
            },
            { path: "d3", type: "library", "name": "d3" },
            { path: "c3", type: "library", "name": "c3" }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['recruitment-hub'],
        },
    },
    {
        "url": "/recruitment-hub/video-interviews?job_id&job_pos_cat_code&bucket_id&app_id&single&brand_id&hide_images&video_interview&show_reviewer",
        "loginRequired": true,
        "platformPage": true,
        "showGlobalSearch": true,
        "name": "appLayout.harriSH.access-portal.video-interviews",
        "type": "frontend",
        "params": {
            job_id: { dynamic: true },
            job_pos_cat_code: { dynamic: true },
            bucket_id: { dynamic: true },
            app_id: { dynamic: true },
            brand_id: { dynamic: true },
            single: { dynamic: true },
            hide_images: { dynamic: true },
            video_interview: { dynamic: true },
            show_reviewer: { dynamic: true }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/recruitment-hub/recruitment-hub.downgrade.module");
                }
            },
            { path: "d3", type: "library", "name": "d3" },
            { path: "c3", type: "library", "name": "c3" }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['recruitment-hub', 'rejection_templates'],
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Video Screenings"
            }
        ],
    },
    {
        "url": "/recruitment-hub/interview-availability",
        "loginRequired": true,
        "platformPage": true,
        "showGlobalSearch": true,
        "name": "appLayout.harriSH.access-portal.interview-availability",
        "type": "frontend",
        "params": {},
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/recruitment-hub/recruitment-hub.downgrade.module");
                }
            }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['recruitment-hub', 'interview_availability', 'h-recruitment-hub'],
        },
    },
];
//# sourceMappingURL=recruitment-hub.routes.js.map